import { TriggerTypes } from "@enums/trigger-types";
import { AxnAttributeTypeField } from "@idw-types/data/reference-data/axn";
import { PolicyComponent, FormattedPolicyComponent, FormattedPolicyComponentCondition } from "@idw-types/data/reference-data/generic/policy-component";
import { getTriggerType } from "@utils/policies/policy-component-util";
import { v4 as uuidv4 } from "uuid";

export const formatPolicyComponent = (
    policyComponent: PolicyComponent,
    axnAttributeTypeFields: Array<AxnAttributeTypeField>
): FormattedPolicyComponent => {
    const conditions: Array<FormattedPolicyComponentCondition> = policyComponent.conditions.map(condition => {
        const uuid = uuidv4();
        let attributeTypeID = null;
        const triggerType = getTriggerType(condition);
        if ([TriggerTypes.ACQUIRED_DATA, TriggerTypes.USER_INPUT].includes(triggerType)) {
            const attributeField = axnAttributeTypeFields.find(typeField => typeField.id === condition.attributeFieldID);
            if (attributeField) {
                attributeTypeID = attributeField.attributeTypeID;
            }
        }

        return {
            ...condition,
            uuid,
            attributeTypeID,
            triggerType
        };
    });

    return {
        ...policyComponent,
        conditions
    };
}